export enum MessageStatus {
    Accepted = 'accepted',
    Pending = 'pending',
    Sent = 'sent',
    Delivered = 'delivered',
    Rejected = 'rejected',
    Failed = 'failed',
    Read = 'read',
    Received = 'received',
    Deleted = 'deleted',
    Unknown = 'unknown',
    Transmitted = 'transmitted',
}
